import { cn } from "@/lib/utils"

type TabDirtyDotTone = "danger" | "approved"

type TabDirtyDotProps = {
  className?: string
  ariaLabel?: string
  /** `danger` (default) for tab unseen changes; `approved` for ready-unread Agents rows. */
  tone?: TabDirtyDotTone
}

const TONE_BG: Record<TabDirtyDotTone, string> = {
  danger: "bg-red-500",
  // Explicit emerald: light --ui-status-approved is sage-4 (olive/grey), not readable as green.
  approved: "bg-emerald-500",
}

/** Small pulsing dot marking unseen changes (tabs) or ready-unread activity. */
export function TabDirtyDot({ className, ariaLabel, tone = "danger" }: TabDirtyDotProps) {
  const bg = TONE_BG[tone]
  return (
    <span
      role={ariaLabel ? "status" : undefined}
      aria-label={ariaLabel}
      className={cn("absolute top-[4px] right-0 flex h-1 w-1", className)}
    >
      <span className={cn("absolute inline-flex h-full w-full animate-ping rounded-full opacity-75", bg)} />
      <span className={cn("relative inline-flex h-1 w-1 rounded-full", bg)} />
    </span>
  )
}
